export default customElements.define('w-announcement', class Announcement extends wealthify.CustomElementBaseClass {

    constructor () {
        const styleSelector = 'c-announcement';
        const config = {
            styleSelector,
            templateHTML: /*html*/`
            <div class="${styleSelector}__container" data-root>
                <div class="${styleSelector}__header" data-header>
                    <w-icon class="${styleSelector}__icon" size="150" data-icon></w-icon>
                    <h2 class="${styleSelector}__heading" data-heading></h2>
                    <w-widget-button icon="cross" class="${styleSelector}__dismiss-button" data-dismissbutton></w-widget-button>
                </div>
                <div class="${styleSelector}__content" data-child-root></div>
            </div>`,
            hasChildren: true,
            cacheDom: [ 'data-header', 'data-icon', 'data-heading', 'data-dismissbutton' ]
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);

            if (!this.hasChildrenAssigned) {
                this.dom.header.classList.add('u-margin__bottom-mobile--0');
            }
        };
    }

    static get typeEnums () {
        return {
            Default: 'default',
            Error: 'error',
            Offer: 'offer',
            Warning: 'warning',
        };
    }

    static get typeIconDictionary () {
        return {
            [this.typeEnums.Default]: 'megaphone',
            [this.typeEnums.Warning]: 'warning-outlined',
            [this.typeEnums.Error]: 'warning-outlined',
            [this.typeEnums.Offer]: 'gift',
        };
    }

    static get typeIcon () {
        return this.contructor.typeIconDictionary[this.type];
    }

    static get validTypes () {
        return Object.values(this.typeEnums);
    }

    static get observedProps () {
        return [
            new wealthify.Prop('closeable', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('heading'),
            new wealthify.Prop('inverted', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('inline', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('open', {
                default: true,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('oncloseclick', {type: wealthify.propTypes.Function()}),
            new wealthify.Prop('type', {
                default: this.typeEnums.Default,
                type: wealthify.propTypes.ArrayItem(this.validTypes)
            })
        ];
    }

    get propCallbacks () {
        return { 
            closeable: () => {
                const classListAction = this.closeable ? 'remove' : 'add';

                this.dom.dismissbutton.classList[classListAction]('u-display__none');

                if (this.closeable) {
                    this._setOnClick();
                }
            },
            open: () => {
                const classListAction = this.open ? 'remove' : 'add';

                this.classList[classListAction]('u-display__none');
            },
            oncloseclick: () => this._setOnClick(),
            heading: () => {
                this.dom.heading.textContent = this.heading;
            },
            inverted: () => {
                const classListAction = this.inverted ? 'add' : 'remove';

                this.dom.root.classList[classListAction](`${this.styleSelector}__container--inverted`);
                this.dom.icon.classList[classListAction](`${this.styleSelector}__icon--inverted`);
            },
            inline: () => {
                const classListAction = this.inline ? 'add' : 'remove';

                this.dom.root.classList[classListAction](`${this.styleSelector}__container--inline`);
            },
            type: () => {
                this.constructor.validTypes.forEach((type) => {
                    this.classList.remove(`${this.styleSelector}--type-${type}`);
                });

                this.classList.add(`${this.styleSelector}--type-${this.type}`);
                this.dom.icon.type = this.constructor.typeIconDictionary[this.type];
            }
        };
    }

    _setOnClick () {
        this.dom.dismissbutton.onclick = function () {
            const transitionDelay = Number.parseFloat(getComputedStyle(this).transitionDuration) * 1000;

            if (this.oncloseclick) {
                this.oncloseclick();
            }
            this.classList.add(`${this.styleSelector}--dismissed`);
            setTimeout(() => {
                this.open = false;
            }, transitionDelay);
        }.bind(this);
    }
});